import { Component } from '@angular/core';

@Component({
    selector: 'pim-no-permission',
    templateUrl: './no-permission.component.html',
    styleUrls: ['./no-permission.component.sass'],
    standalone: false
})
export class NoPermissionComponent {
}
